import { Chip, Group, Text, Stack } from '../../../components/gab/GabComponents';

const IA_DAMAGE_TYPES = [
  { value: 'roof', label: 'Roof', icon: 'fa-house-chimney-crack' },
  { value: 'foundation', label: 'Foundation', icon: 'fa-house-crack' },
  { value: 'flooding', label: 'Flooding', icon: 'fa-house-flood-water' },
  { value: 'wind', label: 'Wind', icon: 'fa-wind' },
  { value: 'tree', label: 'Tree/Debris', icon: 'fa-tree' },
  { value: 'fire', label: 'Fire', icon: 'fa-fire' },
  { value: 'structural', label: 'Structural', icon: 'fa-building-circle-xmark' },
  { value: 'other', label: 'Other', icon: 'fa-circle-exclamation' },
];

const PA_DAMAGE_TYPES = [
  { value: 'road', label: 'Road Damage', icon: 'fa-road-barrier' },
  { value: 'bridge', label: 'Bridge', icon: 'fa-bridge-water' },
  { value: 'power', label: 'Power Lines', icon: 'fa-bolt' },
  { value: 'utility', label: 'Utility', icon: 'fa-plug-circle-xmark' },
  { value: 'vehicle', label: 'Vehicle', icon: 'fa-car-burst' },
  { value: 'erosion', label: 'Erosion', icon: 'fa-mountain-sun' },
  { value: 'school', label: 'School', icon: 'fa-school' },
  { value: 'hospital', label: 'Hospital/Medical', icon: 'fa-hospital' },
  { value: 'government', label: 'Government Building', icon: 'fa-building-columns' },
  { value: 'community', label: 'Community Facility', icon: 'fa-people-roof' },
  { value: 'water-system', label: 'Water/Sewer System', icon: 'fa-faucet-drip' },
  { value: 'communications', label: 'Communications', icon: 'fa-tower-cell' },
  { value: 'park', label: 'Park/Recreation', icon: 'fa-tree-city' },
  { value: 'debris', label: 'Debris Field', icon: 'fa-dumpster' },
  { value: 'other', label: 'Other', icon: 'fa-circle-exclamation' },
];

const ALL_DAMAGE_TYPES = [...IA_DAMAGE_TYPES, ...PA_DAMAGE_TYPES.filter(
  pa => !IA_DAMAGE_TYPES.some(ia => ia.value === pa.value)
)];

interface Props {
  value?: string[];
  onChange: (val: string[]) => void;
  mode?: 'all' | 'ia' | 'pa';
}

export default function DamageTypeSelector({ value = [], onChange, mode = 'all' }: Props) {
  const types = mode === 'ia' ? IA_DAMAGE_TYPES
    : mode === 'pa' ? PA_DAMAGE_TYPES
    : ALL_DAMAGE_TYPES;

  return (
    <Stack gap="xs">
      <Text fw={500} size="sm">Damage Types</Text>
      <Chip.Group multiple value={value} onChange={onChange}>
        <Group gap={6}>
          {types.map(dt => (
            <Chip key={dt.value} value={dt.value} size="sm" variant="outline">
              <i className={`fa-solid ${dt.icon}`} style={{ marginRight: 6, fontSize: 11 }} />
              {dt.label}
            </Chip>
          ))}
        </Group>
      </Chip.Group>
    </Stack>
  );
}
